import { useEffect, useState } from 'react';

// CROSS down (col 1) and WORD across (row 2) intersect at the shared O.
// Letters type out in this order; the O is typed once, with the down word.
const TYPE_ORDER: Array<{ row: number; col: number; letter: string }> = [
  { row: 0, col: 1, letter: 'C' },
  { row: 1, col: 1, letter: 'R' },
  { row: 2, col: 1, letter: 'O' },
  { row: 3, col: 1, letter: 'S' },
  { row: 4, col: 1, letter: 'S' },
  { row: 2, col: 0, letter: 'W' },
  { row: 2, col: 2, letter: 'R' },
  { row: 2, col: 3, letter: 'D' },
];

// Standard crossword numbering (row-major): C starts 1-Down, W starts 2-Across
const CELL_NUMBERS: Record<string, number> = { '0:1': 1, '2:0': 2 };

const TYPE_START_MS = 300;
const TYPE_STEP_MS = 150;

type Phase = 'typing' | 'mark' | 'expanded';

// Types CROSS and WORD into intersecting game-styled cells, then pops a red
// superscript "MP" mark on WORD that expands into "Multi-Player".
export function CrosswordBanner() {
  const [typed, setTyped] = useState(0);
  const [phase, setPhase] = useState<Phase>('typing');

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setTyped(TYPE_ORDER.length);
      setPhase('expanded');
      return;
    }
    const timers: number[] = [];
    for (let i = 1; i <= TYPE_ORDER.length; i += 1) {
      timers.push(window.setTimeout(() => setTyped(i), TYPE_START_MS + i * TYPE_STEP_MS));
    }
    const typedAt = TYPE_START_MS + TYPE_ORDER.length * TYPE_STEP_MS;
    timers.push(window.setTimeout(() => setPhase('mark'), typedAt + 400));
    timers.push(window.setTimeout(() => setPhase('expanded'), typedAt + 1400));
    return () => timers.forEach((timer) => window.clearTimeout(timer));
  }, []);

  return (
    <div className="banner">
      <h1 className="sr-only">Crossword Multi-Player</h1>
      <div aria-hidden="true" className="banner-cross">
        {TYPE_ORDER.map((cell, index) => (
          <span
            className={`banner-cell ${index === typed ? 'cursor' : ''}`}
            key={`${cell.row}:${cell.col}`}
            style={{ gridArea: `${cell.row + 1} / ${cell.col + 1}` }}
          >
            {CELL_NUMBERS[`${cell.row}:${cell.col}`] && (
              <span className="banner-num">{CELL_NUMBERS[`${cell.row}:${cell.col}`]}</span>
            )}
            {index < typed ? cell.letter : ''}
          </span>
        ))}
        <sup
          className={`banner-mark ${phase !== 'typing' ? 'visible' : ''} ${
            phase === 'expanded' ? 'expanded' : ''
          }`}
        >
          M<span className="mark-rest">ulti-</span>P<span className="mark-rest">layer</span>
        </sup>
      </div>
    </div>
  );
}
